import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/src/app/(public)/for-manufacturers/page.tsx");
